// React
import { FunctionComponent } from "react";
// StructureMap
import { Title } from "@fyrstain/hl7-front-library";
// Components
import JanusPage from "../../components/JanusPage/JanusPage";
// Styles
import "./Home.css";

const Home: FunctionComponent = () => {
  //////////////////////////////
  //          Content         //
  //////////////////////////////

  return (
    <JanusPage loading={false} fitFooter={true} needsLogin={false}>
      <>
        <div className="h-100 d-flex justify-content-center align-items-center flex-md-row flex-column gap-3">
          <div>
            <img
              className="home-image-icon"
              alt="Home_image"
              src={(process.env.PUBLIC_URL ?? "") + "/assets/home.png"}
            />
          </div>
          <div>
            <Title level={1} prefix="Janus" content="Structure Maps & Questionnaires" />
          </div>
        </div>
      </>
    </JanusPage>
  );
};

export default Home;
